/* ==========================================================================
   NUKKA — newsletter.js
   Passive enhancement ONLY. The form MUST submit natively so Shopify's
   spam-protection (hCaptcha) can attach its token on the submit event —
   never preventDefault / AJAX this form, or it fails with
   "Missing CAPTCHA token". Here we (1) clear the field + announce the
   server-rendered status after a successful reload, and (2) surface a
   prominent toast so the confirmation isn't lost at the bottom of the page.
   ========================================================================== */
(function () {
  'use strict';
  var N = window.NUKKA || (window.NUKKA = {});

  function toast(msg) {
    if (document.querySelector('.nl-toast')) return;
    var t = document.createElement('div');
    t.className = 'nl-toast';
    t.setAttribute('role', 'status');
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    setTimeout(function () { t.classList.remove('is-in'); setTimeout(function () { t.remove(); }, 400); }, 5000);
  }

  N.register(function (scope) {
    scope.querySelectorAll('[data-newsletter], .newsletter__form, .footer__news-form').forEach(function (form) {
      if (form._init) return; form._init = true;
      var status = form.parentNode.querySelector('.form-status--success');
      if (status && status.textContent.trim()) {
        var input = form.querySelector('input[type="email"]');
        if (input) input.value = '';
        status.setAttribute('tabindex', '-1');
        try { status.focus(); } catch (e) {}
        toast('☕ You’re subscribed! Watch your inbox for good coffee & detours.');
      }
    });
    // Fallback: Shopify appends ?customer_posted=true on a successful newsletter sign-up.
    if (/[?&]customer_posted=true/.test(location.search)) toast('☕ You’re subscribed! Watch your inbox.');
  });
})();
